// extracted by mini-css-extract-plugin
export var bodySections = "_ah-8";
export var gray = "_ah-7";
export var green = "_ah-4";
export var iconContainer = "_ah-9";
export var iconWidgetContainer = "_ah-1";
export var phoneIcon = "_ah-2";
export var red = "_ah-5";
export var statusDot = "_ah-3";
export var widgetContainer = "_ah-0";
export var yellow = "_ah-6";